/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RowStateInfoTypeConstants } from './RowStateInfoTypeConstants';
import {
    RowStateInfoTypeConstantsFromJSON,
    RowStateInfoTypeConstantsFromJSONTyped,
    RowStateInfoTypeConstantsToJSON,
} from './RowStateInfoTypeConstants';

/**
 * 
 * @export
 * @interface RowStateInfo
 */
export interface RowStateInfo {
    /**
     * 
     * @type {string}
     * @memberof RowStateInfo
     */
    title?: string;
    /**
     * 
     * @type {RowStateInfoTypeConstants}
     * @memberof RowStateInfo
     */
    rowStateInfoType?: RowStateInfoTypeConstants;
}

/**
 * Check if a given object implements the RowStateInfo interface.
 */
export function instanceOfRowStateInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RowStateInfoFromJSON(json: any): RowStateInfo {
    return RowStateInfoFromJSONTyped(json, false);
}

export function RowStateInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RowStateInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'rowStateInfoType': !exists(json, 'rowStateInfoType') ? undefined : RowStateInfoTypeConstantsFromJSON(json['rowStateInfoType']),
    };
}

export function RowStateInfoToJSON(value?: RowStateInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'rowStateInfoType': RowStateInfoTypeConstantsToJSON(value.rowStateInfoType),
    };
}

